import Phaser from 'phaser';
import { CST } from '../../../CST';
import { Score } from '../../../controller/score.js';

var pos = 0;

export default class Storyboard_4 extends Phaser.Scene {
	constructor() {
		super(CST.SCENES.STORYBOARD_4);
	}

	init() {
		pos = 0;
	}

	preload() {
		this.load.image('repetition-bg', 'assets/Storyboards/repetition_background.png');
	}

	create(data) {
		const map = this.add.image(0, 0, 'repetition-bg').setOrigin(0);

		const cam = this.cameras.main;
		cam.setBounds(0, 0, 4401, 5980); //Left, Top, X Limit, Y Limit
		cam.setZoom(0.35); //0.8
		cam.centerOn(0, 1010); //1100, 800

		this.clickSound = this.sound.add('click-sound', {
			volume: 0.5,
		});

		this.score = new Score(this);
		this.User_ID = data.User_ID;

		data.next
			.setInteractive({
				useHandCursor: true,
			})
			.on(
				'pointerdown',
				() => {
					this.clickSound.play();
					pos++;
					data.next.disableInteractive();
					data.previous.disableInteractive();
					setTimeout(() => {
						data.next.setInteractive();
						data.previous.setInteractive();
					}, 1500);
					switch (pos) {
						case -1:
							pos = 0;
							break;
						case 1:
							cam.pan(0, 2200, 1000);
							break;
						case 2:
							cam.pan(0, 4600, 1000);
							break;
						case 3:
							pos = 0;
							data.next.setVisible(false);
							data.previous.setVisible(false);
							data.pause.setVisible(false);
							this.scene.resume(CST.SCENES.MAIN_QUESTIONS, {
								User_ID: this.User_ID,
								story: 4,
							});
							this.scene.stop();
							break;
					}
				},
				this,
			);

		data.previous
			.setInteractive({
				useHandCursor: true,
			})
			.on(
				'pointerdown',
				() => {
					this.clickSound.play();
					pos--;
					data.next.disableInteractive();
					data.previous.disableInteractive();
					setTimeout(() => {
						data.next.setInteractive();
						data.previous.setInteractive();
					}, 1500);
					switch (pos) {
						case -1:
							pos = 0;
							break;
						case 0:
							cam.pan(0, 1010, 1000);
							break;
						case 1:
							cam.pan(0, 2200, 1000);
							break;
						case 2:
							cam.pan(0, 4600, 1000);
							break;
					}
				},
				this,
			);
	}
}
